// const isTest1 = document.querySelector('.test-1-variant-1')
const isTest22 = document.querySelector('.test-2-variant-1-2')
const isTest7 = document.querySelector('.test-7-variant-1')
const isTest8 = document.querySelector('.test-8-variant-1')
const isTest10 = document.querySelector('.test-10-variant-1')


class CollectionPageChanges {
    constructor() {
        this.init();
    }

    highlightCurrentCollection() {
        const currentPath = decodeURIComponent(window.location.pathname);
        
        const collectionLinks = document.querySelectorAll('.ss-circle-menu-2-section a.swiper-slide');
        
        collectionLinks.forEach(link => {
            const href = link.getAttribute('href');
            if (!href) return;

            const linkPath = decodeURIComponent(href);
            
            if (currentPath === linkPath || currentPath.startsWith(linkPath + '/')) {
                link.classList.add('is-active-collection');
            }
        });
    }

    increaseSwiperGap() {
        if (window.innerWidth >= 768) return;
        const newGapSize = 16; 
        
        const swiperContainer = document.querySelector('.ss-circle-menu-2-section .swiper');
        
        if (swiperContainer && swiperContainer.swiper) {
            swiperContainer.swiper.params.spaceBetween = newGapSize;
            swiperContainer.swiper.params.slidesPerView = 3.2
            swiperContainer.swiper.update(); 
        }
    }

    init() {
        // this.changeBreadcrumbIcons();
        this.highlightCurrentCollection();
        
        setTimeout(() => {
            this.increaseSwiperGap();
        }, 200);

    }
}

if(window.location.pathname.includes('/collections/') && document.querySelector('[id*="__ss_circle_menu_2"]')){
    new CollectionPageChanges()
}

/****** Test 1  DOne*********/
// class CollectionPageTest {
//     constructor() {
//         this.init();
//     }

//     changeBreadcrumbIcons() {
//         document.querySelectorAll('.breadcrumbs__icon').forEach(icon => icon.innerHTML = '/');
//     }
    
//     highlightCurrentCollection() {
//         const currentPath = decodeURIComponent(window.location.pathname);
        
//         const collectionLinks = document.querySelectorAll('.ss-circle-menu-2-section a.swiper-slide');
        
//         collectionLinks.forEach(link => {
//             const href = link.getAttribute('href');
//             if (!href) return;

//             const linkPath = decodeURIComponent(href);
            
//             if (currentPath === linkPath || currentPath.startsWith(linkPath + '/')) {
//                 link.classList.add('is-active-collection');
//             }
//         });
//     }

//     increaseSwiperGap() {
//         if (window.innerWidth >= 768) return;
//         const newGapSize = 16; 
        
//         const swiperContainer = document.querySelector('.ss-circle-menu-2-section .swiper');
        
//         if (swiperContainer && swiperContainer.swiper) {
//             swiperContainer.swiper.params.spaceBetween = newGapSize;
//             swiperContainer.swiper.params.slidesPerView = 3.2
//             swiperContainer.swiper.update(); 
//         }
//     }

//     init() {
//         this.changeBreadcrumbIcons();
//         this.highlightCurrentCollection();
        
//         setTimeout(() => {
//             this.increaseSwiperGap();
//         }, 200);

//     }
// }
// if(isTest1)
//     new CollectionPageTest()

/****** Test 1 End *****/

/****** Test 2 2.0 **********/



/****** Test 2**********/
class ProductPageTest {
    constructor() {
        this.pollAttempts = 0;
        this.maxAttempts = 10;
        this.isEngravable = document.querySelector('[data-product-is-engravable="true"]')
        this.isEngravable && this.init();
    }

    setMediaHeightVariable() {
        if (window.innerWidth < 768) return;

        const mediaContainer = document.querySelector('.product__media-container.above-mobile .product__media');
        if (mediaContainer) {
            const parent = mediaContainer.parentElement;
            if (parent) {
                const mediaHeight = mediaContainer.offsetHeight;
                parent.style.setProperty('--media-height', `${mediaHeight}px`);
                
                if (!mediaContainer.dataset.resizeListener) {
                    window.addEventListener('resize', () => {
                        if (window.innerWidth >= 768) {
                            parent.style.setProperty('--media-height', `${mediaContainer.offsetHeight}px`);
                        } else {
                            parent.style.removeProperty('--media-height');
                        }
                    });
                    mediaContainer.dataset.resizeListener = 'true';
                }
            }
        }
    }

    moveReviewStars() {
        const title = document.querySelector('.product__title');
        const reviewBadge = document.querySelector('.jdgm-preview-badge');
        if (title && reviewBadge) {
            const reviewBadgeBlock = reviewBadge.closest('.shopify-app-block') || reviewBadge;
            title.after(reviewBadgeBlock);
        }
    }

    moveAfterpay() {
        const price = document.querySelector('.product__price-and-ratings');
        const afterpay = document.querySelector('square-placement');
        if (price && afterpay) {
            const afterpayBlock = afterpay.closest('.shopify-app-block') || afterpay;
            price.after(afterpayBlock);
        }
    }

    modifyEngraveButton() {
        const engraveBtn = document.querySelector('.pplr-c-button');
        if (engraveBtn) {
            engraveBtn.style.width = '100%';
            engraveBtn.style.display = 'block';
            engraveBtn.style.marginBottom = '10px';
            engraveBtn.innerText = 'Engrave'
        }
    }

    modifyNativeAtcButton() {
        const checkboxContainer = document.querySelector('.enable-engrave-product-option');
        if (checkboxContainer) {
            checkboxContainer.style.display = 'none';
            setTimeout(()=>{
                checkboxContainer.querySelector('#enable-engrave').checked == false && checkboxContainer.querySelector('#enable-engrave').click();
            },500)
        }

        const nativeAtcBtn = document.querySelector('.product-form__cart-submit');
        const nativeAtcText = document.querySelector('.product-form__cart-submit [data-add-to-cart-text]');

        if (nativeAtcBtn && nativeAtcText && !nativeAtcBtn.dataset.modified) {
            nativeAtcText.textContent = 'Add to Bag (No Engrave)';
            nativeAtcBtn.dataset.modified = "true";
            nativeAtcBtn.disabled = false;
            nativeAtcBtn.classList.remove('disabled')

      
        }
    }

    createPleaseNote(){
        if(document.querySelector('.test-please-note')) return;
         const accordions = [
            ...document.querySelectorAll(".product__meta .product-accordion-group .accordion"),
        ];
        const materialAccordion = accordions.find((accordion) =>
            accordion
            .querySelector(".accordion__label h3")
            ?.textContent.trim()
            .includes("Material")
        );
        const careAccordion = accordions.find((accordion) =>
            accordion
            .querySelector(".accordion__label h3")
            ?.textContent.trim()
            .includes("Care")
        );
        if (!materialAccordion || !careAccordion) return;
        const materialHeading = materialAccordion.querySelector(
            ".accordion__label h3"
        );
        const materialContent = materialAccordion.querySelector(
            ".accordion__content"
        );
        const careHeading = careAccordion.querySelector(
            ".accordion__label h3"
        );
        const careContent = careAccordion.querySelector(
            ".accordion__content"
        );
        const materialHTML = materialContent.innerHTML;
        careHeading.textContent = "Material & Care";
        careContent.innerHTML = `
            <p><strong>Material</strong></p>
            ${materialHTML}

            <p><strong>Care</strong></p>
            ${careContent.innerHTML}
        `;
        materialAccordion.classList.add('test-please-note');
        materialHeading.textContent = "Please Note";
        materialContent.innerHTML = `
            <p>Due to the handcrafted engraving process, small markings or flecks may be present - these add to the charm and individuality of your one-of-a-kind piece.</p>
        `;
    }

    createReturnsAndShippingText(){
        if(document.querySelector('.test-product-disclaimers')) return;
        const div = document.createElement('div')
        div.innerHTML = `<div class="test-product-disclaimers">
            <p class="test-freeshipping">12-Month Warranty · Free shipping over $149</p>
            <p class="test-returns-engrave">No returns accepted if you engrave items.</p>
        </div>`
        const storeAvailability = document.querySelector('form.product-form .store-availability-container__wrapper');
        const productForm = document.querySelector('form.product-form');
        if(storeAvailability){
            storeAvailability.before(div.querySelector('.test-product-disclaimers'))
        }else{
            productForm.appendChild(div.querySelector('.test-product-disclaimers'))
        }
    }

    removeExtraDescription() {
        const descContainer = document.querySelector('.product__description .rte');
        if (!descContainer || descContainer.dataset.extraRemoved) return;

        const firstStrong = descContainer.querySelector('strong');
        if (firstStrong) {
            const nextElement = firstStrong.nextElementSibling;
            if (nextElement && nextElement.tagName === 'BR') {
                nextElement.remove();
            }
            firstStrong.remove();
        }

        let foundChecks = false;
        
        Array.from(descContainer.children).forEach(child => {
            if (child.textContent.includes('✔')) {
                foundChecks = true;
            } 
            else if (foundChecks) {
                child.style.display = 'none';
            }
        });

        descContainer.dataset.extraRemoved = 'true';
    }

    replaceCheckmarksWithSvg() {
        const descContainer = document.querySelector('.product__description .rte');
        
        if (descContainer && !descContainer.dataset.svgReplaced) {
            const checkSvg = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 9C18 11.3869 17.0518 13.6761 15.364 15.364C13.6761 17.0518 11.3869 18 9 18C6.61305 18 4.32387 17.0518 2.63604 15.364C0.948212 13.6761 0 11.3869 0 9C0 6.61305 0.948212 4.32387 2.63604 2.63604C4.32387 0.948212 6.61305 0 9 0C11.3869 0 13.6761 0.948212 15.364 2.63604C17.0518 4.32387 18 6.61305 18 9ZM13.5337 5.59125C13.4534 5.51117 13.3577 5.44812 13.2524 5.40587C13.1471 5.36361 13.0344 5.34303 12.921 5.34534C12.8076 5.34765 12.6958 5.37281 12.5923 5.41931C12.4888 5.46582 12.3958 5.53271 12.3187 5.616L8.41162 10.5941L6.057 8.23837C5.89705 8.08933 5.6855 8.0082 5.46691 8.01205C5.24832 8.01591 5.03976 8.10446 4.88518 8.25905C4.73059 8.41364 4.64204 8.6222 4.63818 8.84079C4.63432 9.05938 4.71546 9.27093 4.8645 9.43088L7.84125 12.4087C7.92144 12.4888 8.01693 12.5519 8.12203 12.5942C8.22713 12.6366 8.33968 12.6573 8.45296 12.6552C8.56625 12.6531 8.67795 12.6282 8.78141 12.582C8.88486 12.5358 8.97795 12.4692 9.05512 12.3863L13.5461 6.7725C13.6992 6.61331 13.7838 6.40043 13.7817 6.17958C13.7796 5.95872 13.691 5.74749 13.5349 5.59125H13.5337Z" fill="#69001A"/>
            </svg>
`;
            
            const regex = /✔\s*([\s\S]*?)(?:<br[^>]*>|(?=<\/p>|$))/gi;
            
            descContainer.innerHTML = descContainer.innerHTML.replace(regex, `
                <div class="custom-check-item">
                    ${checkSvg}
                    <span class="custom-check-text">$1</span>
                </div>
            `);
            
            descContainer.dataset.svgReplaced = 'true';
        }
    }

    moveWidgetsUnderReviews() {
        const reviewCarousel = document.getElementById('jdgm-review-snippet-wrapper');
        const stackSaveText = document.getElementById('bh2o-option-c');
        const completeLook = document.getElementById('bh2o-complete-look');
        const productFormSubmit =document.querySelector('.product-form__controls-group--submit')

        if (productFormSubmit) {
            if (stackSaveText && completeLook) {
                productFormSubmit.after(stackSaveText, completeLook);
            }
        }
    }

    runMutations() {
        this.setMediaHeightVariable();
        this.moveReviewStars();
        this.moveAfterpay();
        this.modifyNativeAtcButton();
        this.createReturnsAndShippingText();
        this.createPleaseNote()
        this.removeExtraDescription(); 
        this.replaceCheckmarksWithSvg();
        this.waitUntilAvailable('.pplr-c-button', this.modifyEngraveButton)
        this.waitUntilAvailable("#bh2o-complete-look", this.moveWidgetsUnderReviews)
    }

    waitUntilAvailable(selector, functionToRun){
        let elapsedTime = 0;
        const awaitingItem = setInterval(()=>{
            if(document.querySelector(selector)){
                clearInterval(awaitingItem);
                functionToRun()
            }
            elapsedTime+=250;
            if(elapsedTime >= 10000)
                clearInterval(awaitingItem)
        }, 250)
    }

    init() {
        this.runMutations();

        const poller = setInterval(() => {
            this.runMutations();
            this.pollAttempts++;
            
            if (this.pollAttempts >= this.maxAttempts) {
                clearInterval(poller);
            }
        }, 500);
    }
}
if(isTest7)
    new ProductPageTest();
/****** Test 2 End *****/

/****** Test 8 Start ********/
const style8 = document.createElement('style');
style8.innerHTML = `
    @media (max-width: 768px){
       .test-8-variant-1 .test-8-hidden {
            display: none !important;
            opacity: 0 !important;
            visibility: hidden !important;
        }
    }
`;
document.head.appendChild(style8);

class Test8 {
    constructor() {
        this.init();
    }
    
    init() {
        const stickyBar = document.querySelector('.sticky-atc-bar');
        const cartSubmit = document.querySelector('.product-form__cart-submit');
        
        if (!stickyBar || !cartSubmit) return;
        
        stickyBar.classList.add('test-8-hidden');
        
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting && entry.boundingClientRect.bottom < 0) {
                    stickyBar.classList.remove('test-8-hidden');
                } else {
                    stickyBar.classList.add('test-8-hidden');
                }
            });
        });
        
        observer.observe(cartSubmit);
    }
}

if (typeof isTest8 !== 'undefined' && isTest8) {
    new Test8();
}
/****** Test 8 End *****/
/****** Test 10 *********/
class Test10 {
    constructor() {
        this.cartState = 0;
        this.init();
    }

    injectStyles() {
        if (document.getElementById('test-10-styles')) return;

        const style = document.createElement('style');
        style.id = 'test-10-styles';
        style.innerHTML = `
            .test-10-variant-1 .product {
                margin-top: 0;
            }
            .test-10-stack-save-wrapper {
                display: none; /* Hidden by default (for desktop) */
            }
            
            /* Scoped entirely to mobile and the variant class */
            @media (max-width: 767px) {
                .test-10-variant-1 .ss-announcement-bar {
                    display: none;
                }
                .test-10-variant-1 .test-10-stack-save-wrapper {
                    display: flex;
                    box-sizing: border-box;
                    gap: 4px;
                    margin: 0;
                    padding: 7px 0 13.5px;
                    margin-left: calc(calc(-1 * var(--space-outer)) + 9px);
                    width: calc(100vw - 18px);
                }
                
                .test-10-variant-1 .test-10-pill {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 3px 16px;
                    border-radius: 40px;
                    /* Scales smoothly to prevent text wrapping on small screens (e.g. iPhone SE) */
                    font-size: clamp(9.5px, 2.7vw, 13px);
                    line-height: 1.2;
                    flex: 1;
                    white-space: nowrap;
                    font-family: inherit;
                    transition: all 0.3s ease;
                }
                
                .test-10-variant-1 .test-10-pill-inactive {
                    border-radius: 99999px;
                    background: #FFDBEF;
                    color: #69001A;
                    font-family: Quicksand;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 13.5px;
                    letter-spacing: 0.425px;
                }
                
                .test-10-variant-1 .test-10-pill-active {
                    background: linear-gradient(90deg, #F7A7A8 0%, #6a0b22 100%);
                    color: #FFF;
                    font-family: Quicksand;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 13.5px;
                    letter-spacing: 0.425px;
                }
                .test-10-variant-1 .test-10-pill-inactive strong,
                .test-10-variant-1 .test-10-pill-active strong{
                    font-weight: 600;
                }
                
                .test-10-variant-1 .test-10-pill strong {
                    font-weight: 600;
                }
                
                .test-10-variant-1 .test-10-icon {
                    display: inline-flex;
                    margin-right: 5px;
                    align-items: center;
                }
                
                .test-10-variant-1 .test-10-icon svg {
                    width: 11px;
                    height: 11px;
                    fill: currentColor;
                }
                
                /* Layout helper for State 4 (3+ Items) */
                .test-10-variant-1 .test-10-pill-full {
                    justify-content: space-between;
                    padding: 4px 16px;
                }
            }

            @media (max-width: 420px){
                .test-10-variant-1 .test-10-pill-inactive {
                    font-size: 10px;
                }
            }
        `;
        document.head.appendChild(style);
    }

    async getCartState() {
        try {
            const res = await fetch(window.Shopify?.routes?.root + 'cart.js' || '/cart.js');
            const cart = await res.json();
            
            let has10Percent = false;
            let has15Percent = false;
            let hasEligibleItems = false;

            if (cart.items && cart.items.length > 0) {
                 cart.items.forEach(item => {
                    if (item.price > 0 && item.product_type !== 'free_gift') {
                        hasEligibleItems = true;
                    }

                    if (item.discounts && item.discounts.length > 0) {
                        item.discounts.forEach(discount => {
                            if (discount.title && discount.title.includes('15%')) {
                                has15Percent = true;
                            } else if (discount.title && discount.title.includes('10%')) {
                                has10Percent = true;
                            }
                        });
                    }
                 });
            }

            if (has15Percent) return 3;
            if (has10Percent) return 2;
            if (hasEligibleItems) return 1;
            
            return 0;

        } catch (e) {
            console.error("Error fetching cart data:", e);
            return 0;
        }
    }

    getProgressBarHTML(state) {
        const starIcon = `<span class="test-10-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 0C12 6.627 17.373 12 24 12C17.373 12 12 17.373 12 24C12 17.373 6.627 12 0 12C6.627 12 12 6.627 12 0Z"/></svg></span>`;

        if (state === 0) {
            return `
                <div class="test-10-pill test-10-pill-inactive">
                    ${starIcon} <span>Stack & Save</span>
                </div>
                <div class="test-10-pill test-10-pill-inactive">
                    <span><strong>10% off</strong> 2 pieces</span>
                </div>
                <div class="test-10-pill test-10-pill-inactive">
                    <span><strong>15% off</strong> 3 pieces</span>
                </div>
            `;
        } else if (state === 1) {
            return `
                <div class="test-10-pill test-10-pill-active">
                    ${starIcon} <span><strong>Stack & Save</strong></span>
                </div>
                <div class="test-10-pill test-10-pill-inactive">
                    <span><strong>10% off</strong> 2 pieces</span>
                </div>
                <div class="test-10-pill test-10-pill-inactive">
                    <span><strong>15% off</strong> 3 pieces</span>
                </div>
            `;
        } else if (state === 2) {
            return `
                <div class="test-10-pill test-10-pill-active" style="flex: 2;">
                    ${starIcon} <span><strong>10% Off unlocked! Next → 15%</strong></span>
                </div>
                <div class="test-10-pill test-10-pill-inactive" style="flex: 1;">
                    <span><strong>15% off</strong> 3 pieces</span>
                </div>
            `;
        } else { 
            return `
                <div class="test-10-pill test-10-pill-active test-10-pill-full">
                    ${starIcon} <span><strong>15% off</strong> applied</span>
                </div>
            `;
        }
    }

    async updateBanner() {
        this.cartState = await this.getCartState();
        const wrapper = document.querySelector('.test-10-stack-save-wrapper');
        
        if (wrapper) {
            wrapper.innerHTML = this.getProgressBarHTML(this.cartState);
        }
    }

    injectBanner() {
        const headerContainer = document.querySelector('header .header__inner');
        
        if (!headerContainer || document.querySelector('.test-10-stack-save-wrapper')) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'test-10-stack-save-wrapper';
        wrapper.innerHTML = this.getProgressBarHTML(this.cartState);

        headerContainer.appendChild(wrapper);
    }

    setupCartObserver() {
        const originalFetch = window.fetch;
        window.fetch = async (...args) => {
            const response = await originalFetch(...args);
            const url = args[0];
            
            if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear'))) {
                setTimeout(() => this.updateBanner(), 600); // Brief delay for apps/drawer to catch up
            }
            return response;
        };

        document.body.addEventListener('click', (e) => {
            if (e.target.closest('form[action*="/cart/add"] button, .quick-cart__submit, .quantity-input')) {
                setTimeout(() => this.updateBanner(), 1000);
            }
        });
    }

    async init() {
        this.injectStyles();
        this.cartState = await this.getCartState(); 
        this.injectBanner();
        this.setupCartObserver(); 
    }
}

if (typeof isTest10 !== 'undefined' && isTest10) {
    new Test10();
}
/****** Test 10 End *****/




/**** Test 2 Done */
function setMediaHeightVariable() {
    if (window.innerWidth < 768) return;

    const mediaContainer = document.querySelector('.product__media-container.above-mobile .product__media');
    if (mediaContainer) {
        const parent = mediaContainer.parentElement;
        if (parent) {
            // Get the height and set it as a CSS variable on the parent
            const mediaHeight = mediaContainer.offsetHeight;
            parent.style.setProperty('--media-height', `${mediaHeight}px`);
            
            if (!mediaContainer.dataset.resizeListener) {
                window.addEventListener('resize', () => {
                    if (window.innerWidth >= 768) {
                        parent.style.setProperty('--media-height', `${mediaContainer.offsetHeight}px`);
                    } else {
                        parent.style.removeProperty('--media-height');
                    }
                });
                mediaContainer.dataset.resizeListener = 'true';
            }
        }
    }
}
setMediaHeightVariable()
/**** Test 2 Done End*/
